import { connect, ConnectedProps } from 'react-redux';
import {
  buildDateFilter,
  buildAggregationFilters,
} from '../search-snippets/aside/filter-box/filterBoxUtils';
import {
  hasAggregation,
  hasAggregationSelected,
} from './searchFiltersBarUtils';
import { StateType } from '../../../state/reducers';

const mapState = ({ aggregations, queryParams }: StateType) => ({
  type: queryParams.type,
  shouldDisplayTextCode: hasAggregation(aggregations, 'textCode'),
  shouldDisplayOtherLegislation: hasAggregation(
    aggregations,
    'otherLegislation',
  ),
  shouldDisplayCollectiveAgreements: hasAggregation(
    aggregations,
    'collectiveAgreements',
  ),
  shouldDisplayDate: aggregations.dates && aggregations.dates.length,
  hasDomaineSelected: hasAggregationSelected(queryParams, 'domaine'),

  hasDateSelected: !!queryParams.dates.exact,
  hasTextCodeSelected: hasAggregationSelected(queryParams, 'textCode'),
  hasCollectiveAgreementsSelected: hasAggregationSelected(
    queryParams,
    'collectiveAgreements',
  ),
  hasOtherLegislationSelected: hasAggregationSelected(
    queryParams,
    'otherLegislation',
  ),
  dateLabel: queryParams.dates ? buildDateFilter(queryParams.dates) : null,
  textCodeCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'textCode',
  ).length,
  collectiveAgreementsCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'collectiveAgreements',
  ).length,
  otherLegislationCount: buildAggregationFilters(
    queryParams.aggregationsPaths,
    'otherLegislation',
  ).length,
});

export const Connect = connect(mapState);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
